import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Loader from './../shared/loader'
import router from '../../../router'
import moment from 'moment'
export default {
	name: 'Packing',
	components: {
		Loader,
	},
	data: function() {
		return {
			UnpackBoxid: false,
			splitboxDone: true,
			errorofsplitbox: false,
			showSpilitDeatils: false,
			btnDisable: false,
			isprinttrue: false,
			awbnoForPrint: '',
			clientidForPrint: '',
			orderidForPrint: '',
			shippingcompanyForPrint: '',
			warehouseidForPrint: '',
			printInvoiceEnable: false,
			printLabelEnable: false,
			orderDetails: {},
			showOrderDetails: false,
			orderstatus: '',
			minisocheck: false,
			boxl: '',
			boxb: '',
			boxh: '',
			isLoading: false,
			clientid: '',
			boxerrors: '',
			weighterrors: '',
			isError: '',
			loading: false,
			loadingText: '<i class="fa fa-spinner fa-spin fa-2x" style="color:#1985ac"></i>',
			boxdetails: [],
			bid: '',
			addspilitbox: {
				spilitBoxID: '',
				productid: ''

			},
			addbox: {
				boxid: '',
				boxweight: 0,
				orderid: '',
				seller: '',
				awbno: '',
				productimage: '',
				productname: '',
				productquantity: '',
				couriername: '',
				saleschannel: [],
			},
			showboxdetails: false,
			showproductdetails: false,
			showproductdetailsbtn: false,
			showButton: false,
			isRejectReason: false,
			useremail: '',
			totalsku: 0,
			totalquantity: 0,
			productid: '',
			isCheckboxError: '',
			Checkboxerrors: '',
			client: '',
			isscanproducterror: '',
			scanproducterror: '',
			fullErrorMessage: '',
			otherreason: '',
			isOtherReason: '',
			qcstatus: '',
			boxStatus: '',
			qcacceptqty: 0,
			qcrejectqty: 0,
			ProductID: 0,
			checkedNames: [],
			scanproductData: [],
			rejectreasons: [],
			shipmentPrintNotAvailable: false,
			shipmentPrintNotAvailableMSG: '',
			shipmentStatus: '',
			isrubiconshipment: false,
			flag: false,
			flag2: false,
			cancel: 0,
			canceldetails: [],
			cancelmodalShow: false,
			Confirmationcheck: false,
			xbcheck: false,
			xbclientid: '',
			listWarehouseData: [],
			warehouse: '',
			systemLoginCheck: false,
			warehouseLoginCheck: false,
			boxdataproductid: [],
			isUnicommerce: false,
			invoicelabel: '',
			shippinglabel: '',
			shippingcode: '',
			awbForUnicommerce: '',
			courierPartnerForUnicommerce: '',
			uniCommerceLabel: '',
			uniCommerceShipping: '',
			shippinglabelWmall: '',
			invoicelabelWmall: '',
			wmallLabel: '',
			wmallShipping: '',
			isWmall: false,

			spiltdetalsdata: [],
			spiltDestinationdata: [],
			showButtonManualPacking: false,
			showLabelsButtons: true,
			isLoadingNew: false,
			shipByDate: '',
			errormsgForUnpack: true,
			isMultiseller: false,
			flipkartLabelInvoiceStream: [],
			showQCSection: false,
			dynamicSalesChannelList: [],
			xbIntegration: false,
		}
	},
	computed: {
		isComplete2() {
			if (this.errormsgForUnpack == true) {
				return true;
			} else {
				return false;
			}
		},
		isComplete1() {
			if (this.errorofsplitbox == true) {
				return true;
			} else {
				return false;
			}
		},
		isSplitComplete1() {
			if (this.splitboxDone == true) {
				return true;
			} else {
				return false;
			}
		},
	},
	mounted() {
		document.getElementById("checkbox1").checked = false
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;
		this.useremail = userdetail.email;
		this.userid = userdetail.userid;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.systemLoginCheck = true;
				this.warehouseLoginCheck = false;
				this.showSelectClient = true;
				// this.getWarehouseList();
				// this.getClientList();
				break;

			case 'client_user':
				this.systemLoginCheck = false;
				this.warehouseLoginCheck = false;
				this.clientid = userdetail.warehouseid;
				this.getProductData();
				break;

			case 'warehouse_user':
				this.systemLoginCheck = false;
				this.warehouseLoginCheck = true;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		Unpackboxid() {
			this.UnpackBoxid = true
		},
		unpackageboxid() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.isLoading = true;
			this.input = ({
				clientid: Number(this.client),
				warehouseid: this.warehouseid,
				boxid: this.addbox.boxid,



			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'unpackingboxid',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data[0].ErrorCode == 0) {
						this.$alertify.success(result.data.data[0].msg)
						this.UnpackBoxid = false;
						this.showLabelsButtons = false;
						this.errormsgForUnpack = false;
						// this.showOrderDetails = false;
						// this.showboxdetails = true;
						// this.showLabelsButtons = false;
						// this.addbox.boxid ='';

					} else if (result.data.data[0].ErrorCode == -1) {
						this.$alertify.error(result.data.data[0].msg)
						this.UnpackBoxid = false;

					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				});

		},
		dateFormatDetail(date) {
			if (!date) return '';
			return moment(date).format('LLLL');
		},
		getOrderShipByDate(orderid, clientid, warehouseid) {
			this.shipByDate = ''
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '')
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getOrderShipByDateApi',
					'data': {
						orderid: orderid,
						clientid: clientid,
						warehouseid: warehouseid,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
						if (result.data.errorCode == 0) {
							this.shipByDate = result.data.data[0].shipbydate
						}
					},
					error => {
						console.error(error)
					})
		},

		systemLogin() {
			this.warehouseid = this.warehouse
		},
		// async getWarehouseList() {
		// 	try {
		// 		this.isLoading = true
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '')
		// 		let result = await axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': {},
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		this.listWarehouseData = result.data.data;
		// 		this.isLoading = false
		// 	} catch (err) {
		// 		console.log(err);
		// 	}
		// },
		getDestinationspiltdetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');


			this.input = ({
				clientid: this.client,
				orderid: this.addbox.orderid,
				productid: this.productid,
				warehouseid: this.loginwarehouseid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'GetBoxspiltDetailsData',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					console.log(result.data.data);
					this.spiltDestinationdata = result.data.data;

					let totalRows = result.data.data.count;
					if (totalRows < 10) {
						this.pagecountorder = 1
					} else {
						this.pagecountorder = Math.ceil(totalRows / 10)
					}
				}, error => {
					console.error(error)
				})
		},
		getspiltdetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');


			this.input = ({
				clientid: this.client,
				boxid: this.addbox.boxid,
				warehouseid: this.loginwarehouseid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'GetBoxspiltData',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					console.log(result.data.data);
					this.spiltdetalsdata = result.data.data;
					let totalRows = result.data.data.count;
					if (totalRows < 10) {
						this.pagecountorder = 1
					} else {
						this.pagecountorder = Math.ceil(totalRows / 10)
					}
				}, error => {
					console.error(error)
				})
		},

		getConfigdetails(clientid) {
			this.xbclientid = clientid;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: clientid,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getconfigdetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result) {
						for (var i = 0; i < result.data.length; i++) {
							if (result.data[i].type == 'xb_ecom_ONOFF' && result.data[i].value == 'yes') {
								this.xbcheck == true;
								this.addbox.awbno = '';
								//	document.getElementById("awbno").disabled = true;
							}
						}
					} else {
						this.$alertify.error("Configdetails Not Found");
					}
				}, error => {
					console.error(error);
				});
		},
		getxbawb() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.xbclientid,
				boxid: Number(this.addbox.boxid),
				warehouseid: this.warehouseid,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getxbAWBPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.ReturnCode == 100) {
						this.addbox.awbno = result.data.AWBNo;
						this.checkAwb();
					} else {
						this.$alertify.error("XB AWB Not Found");
						return false;
					}
				}, error => {
					console.error(error);
				});
		},

		yescancelmodal() {
			this.cancelmodalShow = false
			this.Confirmationcheck = true
			if (this.xbcheck == true) {
				this.getxbawb()
			} else {
				this.checkAwb()
			}
		},
		closeStatuscancelModal() {
			this.cancelmodalShow = false
			this.Confirmationcheck = false
		},
		SpiltBoxModal() {
			this.splitboxDone = false;
			this.showSpilitDeatils = true;
			this.fullErrorMessage = '';
			this.getspiltdetails();

		},
		addSpiltBox() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.addspilitbox.productid == '' || this.addspilitbox.productid == null) {
				this.$alertify.error("Product ID required");
				return false;
			}

			for (var i = 0; i < this.spiltdetalsdata.length; i++) {
				if (this.spiltdetalsdata[i].productid == this.addspilitbox.productid || this.spiltdetalsdata[i].eancode == this.addspilitbox.productid) {
					if (this.spiltdetalsdata[i].productqty == 1) {
						this.splitboxDone = true;
						this.resetSpiltBox();
						this.$alertify.error("Spilt Box Can Not Done,Product quantity should be greater than 1");
						return false;
					}

				}
			}

			this.input = ({
				"boxid": Number(this.addbox.boxid),
				"productid": this.addspilitbox.productid,
				"useremail": this.useremail,
				"clientid": Number(this.client),
				"warehouseid": Number(this.warehouseid),
				"orderid": this.addbox.orderid,
				"newboxid": Number(this.addspilitbox.spilitBoxID),
				"userid": this.userid,
				"itemid": this.itemid,
				"shipmentid": this.shipmentid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'splitBoxPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data[0].ErrorCode == 0) {
						this.$alertify.success("Box Splitted Successfully");
						this.getspiltdetails();
						this.getDestinationspiltdetails();
						this.resetSpiltBox();
						this.showSpilitDeatils = true;
						this.splitboxDone = false;

					} else {
						this.$alertify.error("Invalid Box / Data Mismatched");
						this.showSpilitDeatils = true;
						this.splitboxDone = false;
						return false;
					}
				}, error => {
					console.error(error);
				});
		},
		confirmationmodal() {
			if (this.cancel == 0 || this.cancel < 0) {
				if (this.xbcheck == true) {
					this.getxbawb()
				} else {
					this.checkAwb()
				}
			} else {
				this.cancelmodalShow = true
				this.Confirmationcheck = false
			}
			this.addspilitbox.spilitBoxID = '';
			this.addspilitbox.productid = '';
		},
		resetFormDetails() {
			this.showboxdetails = false;
		},
		// getClientList() {
		// 	this.pageNo = this.pageCount = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		// this.pageNo = this.pageCount = 0;
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		getBoxDetails: function(check) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			if (!this.warehouse && this.systemLoginCheck && !this.warehouseLoginCheck) {
				this.$alertify.error(this.$t('common.warehousePlaceholder'));
				return false;
			}
			if (this.systemLoginCheck && !this.warehouseLoginCheck) {
				userdetail.warehouseid = this.warehouse
			}
			this.errormsgForUnpack = true;
			this.xbIntegration = false;
			this.showboxdetails = false;
			this.showOrderDetails = false;
			this.shipmentPrintNotAvailable = false;
			this.printInvoiceEnable = false;
			this.printLabelEnable = false;
			this.clientidForPrint = '';
			this.orderidForPrint = '';
			this.shippingcompanyForPrint = '';
			this.warehouseidForPrint = ''
			this.awbnoForPrint = ''
			this.shipmentPrintNotAvailable = false;
			this.shipmentPrintNotAvailableMSG = '';
			this.addbox.couriername = '';
			this.addspilitbox.spilitBoxID = '';
			this.addspilitbox.productid = '';
			this.spiltdetalsdata = [];
			this.spiltDestinationdata = [];
			this.boxdataproductid = [];
			this.showSpilitDeatils = false;
			this.isLoading = true;
			axios({
					method: "post",
					url: apiUrl.api_url + "getboxclient",
					data: ({
						warehouseid: userdetail.warehouseid,
						boxid: this.addbox.boxid,
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((clientdata) => {
					this.isLoading = false;
					this.flag = false;
					this.flag2 = false;

					if (clientdata.data.data[0].ErrorCode == -1) {
						document.getElementById('submitbtn').removeAttribute('disabled');
						this.productCheckIcon = '';
						this.$alertify.error(clientdata.data.data[0].msg);
					} else if (clientdata.data.data[0].ErrorCode == 0) {
						this.dynamicSalesChannelList = clientdata.data.data[0].data[0].dynamicSalesChannelList
						this.flag = true;
						this.client = clientdata.data.data[0].data[0].clientid;
						this.clientname = clientdata.data.data[0].data[0].clientname;
						var clientid = clientdata.data.data[0].data[0].clientid;
						this.input = ({
							clientid: clientid,
							boxid: this.addbox.boxid,
						});
						this.isLoading = true;
						this.resetInfo();
						axios({
								method: "post",
								url: apiUrl.api_url + "getpackingdetails",
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								},
							})
							.then((response) => {
								if (check == 1) {
									this.getBoxWeight();
								}
								this.isUnicommerce = false;
								this.isMultiseller = false;
								this.isWmall = false;
								this.isrubiconshipment = false;
								this.showLabelsButtons = true;
								this.showButtonManualPacking = false;
								var result = response.data.data;
								var num = [];
								var numcancel = [];
								let product_skus = [];
								this.totalquantity = 0;
								this.cancel = 0;
								this.canceldetails = [];
								if (result[0].ErrorCode == 0) {


									this.isLoading = false;
									if (clientid == 1005 || clientid == 1012) {
										this.minisocheck = true;
										//this.addbox.couriername = "E-Com";
										//	this.addbox.awbno = '';
									}
									//start of Logic for if shipping_id found

									for (var i = 0; i < response.data.data[0].data.boxdata.length; i++) {
										this.boxdataproductid.push({
											"productid": response.data.data[0].data.boxdata[i].productid,
											"eancode": response.data.data[0].data.boxdata[i].eancode
										})

									}
									let shipmentid = response.data.data[0].data.boxdata[0].shipment_id != '' || response.data.data[0].data.boxdata[0].shipment_id != null ? response.data.data[0].data.boxdata[0].shipment_id : '';
									if ((shipmentid == null || shipmentid == '') && response.data.data[0].data.boxdata[0].boxstatus != 'in_shipping') {
										this.shipmentPrintNotAvailable = false;
										this.shipmentPrintNotAvailableMSG = 'Order has no shipment. Get invoice and shipping label from client system.';
									} else if (shipmentid == null || shipmentid == '') {
										this.shipmentPrintNotAvailable = false;
										if (result[0].data.boxdata[0].awbno != '' && result[0].data.boxdata[0].awbno != null && response.data.data[0].data.boxdata[0].boxstatus == 'in_shipping') {
											this.getPrintInvoiceEnableOrDisable(clientid);
											this.clientidForPrint = clientid
											this.orderidForPrint = result[0].data.boxdata[0].order_id
											this.shippingcompanyForPrint = result[0].data.boxdata[0].shippingcompany
											this.warehouseidForPrint = userdetail.warehouseid
											this.awbnoForPrint = result[0].data.boxdata[0].awbno
										}
									} else {
										this.shipmentPrintNotAvailable = true;
									}
									//end of Logic for if shipping_id found

									for (var i = 0; i < response.data.data[0].data.boxdata.length; i++) {
										if (response.data.data[0].data.boxdata[i].cancelqty > 0) {
											numcancel.push(response.data.data[0].data.boxdata[i].cancelqty);
											this.cancel += parseInt(Number(response.data.data[0].data.boxdata[i].cancelqty));
											this.canceldetails.push(
												response.data.data[0].data.boxdata[i],
											);
										}
										num.push(response.data.data[0].data.boxdata[i].pickqty);
										this.totalquantity += parseInt(num[i]);
										if (product_skus.indexOf(response.data.data[0].data.boxdata[i].productid) == -1) {
											product_skus.push(response.data.data[0].data.boxdata[i].productid);
										}
									}
									if (Number(this.cancel) == Number(this.totalquantity)) {
										this.$alertify.error('Packing Cannot be done all products cancelled for this BoxID');
										return false;
									}

									this.totalsku = product_skus.length;
									this.qcacceptqty = response.data.data[0].data.qcData.allQC.totalQCAcceptQty;
									this.qcrejectqty = response.data.data[0].data.qcData.allQC.totalQCRejectQty;
									//this.showboxdetails = true;
									this.boxdetails = result[0].data;

									//start of Logic for if shipping_id found
									let awb_no = response.data.data[0].data.shipmentData != undefined ? response.data.data[0].data.shipmentData.awb_no : ''
									//end of Logic for if shipping_id found
									if (awb_no == '' || awb_no == null) {
										// awb_no = 'Gati1234';
									}
									this.orderDetails = {}
									for (var i = 0; i < result[0].data.boxdata.length; i++) {

										//start of Logic for if shipping_id found
										this.addbox.awbno = result[0].data.boxdata[i].awbnumber != null && result[0].data.boxdata[i].awbnumber != '' ? result[0].data.boxdata[i].awbnumber : awb_no;
										//end of Logic for if shipping_id found
										if (clientid == 1005 || clientid == 1012) {
											this.boxl = result[0].data.boxdata[i].length;
											this.boxb = result[0].data.boxdata[i].width;
											this.boxh = result[0].data.boxdata[i].height
										}
										this.addbox.orderid = result[0].data.boxdata[i].order_id;
										this.addbox.seller = result[0].data.boxdata[i].saleschannel;
										this.boxStatus = result[0].data.boxdata[i].boxstatus;
										this.orderStatus = result[0].data.boxdata[i].status;
										this.getOrderShipByDate(this.addbox.orderid, clientid, userdetail.warehouseid)
										if (result[0].data.boxdata[i].shipment_id == null) {
											result[0].data.boxdata[i].shipment_id = ""
										}

										this.orderDetails = {
											"orderid": result[0].data.boxdata[i].order_id,
											"saleschannel": result[0].data.boxdata[i].saleschannel,
											"shipmentid": result[0].data.boxdata[i].shipment_id,
											"boxproductqty": this.totalquantity - this.cancel,
										}
										if (result[0].data.boxdata[i].awbno && result[0].data.boxdata[i].awbno != '') {
											this.orderDetails.awbno = result[0].data.boxdata[i].awbno
										}
										if (result[0].data.boxdata[i].shippingcompany && result[0].data.boxdata[i].shippingcompany != '') {
											this.orderDetails.shippingcompany = result[0].data.boxdata[i].shippingcompany
										}
										if (result[0].data.boxdata[i].totalorderqty && result[0].data.boxdata[i].totalorderqty != '') {
											if (result[0].data.boxdata[i].totalorderqty == null) {
												this.orderDetails.Orderqty = ''
											} else {
												this.orderDetails.Orderqty = result[0].data.boxdata[i].totalorderqty
											}
										}

									}
									if ((Number(this.qcacceptqty) + Number(this.qcrejectqty) >= (Number(this.totalquantity) - Number(this.cancel))) && Number(this.qcrejectqty > 0)) {
										this.showQCSection = false
									} else {
										this.showQCSection = true
									}
									if ((this.totalquantity - this.cancel) === this.qcacceptqty) {
										this.splitboxDone = true;
										this.showButton = true
									} else {
										this.showButton = false
									}
									if (this.boxStatus == 'in_packing' || this.boxStatus == null || this.boxStatus == 'failed') {
										this.showboxdetails = true
									} else {
										this.showboxdetails = false
										this.$alertify.error('Box has status ' + this.boxStatus + ', hence QC cannot be done');

										if (this.orderStatus == "dispatched" || this.orderStatus == "packed" || this.orderStatus == "rto" || this.orderStatus == "cancelled") {
											this.showOrderDetails = true
										}

									}
									this.addbox.saleschannel = [];

									//check if shipping_id found
									var shipmentIdForUnicommerce = shipmentid
									if (shipmentid == null || shipmentid == '') {

										this.addbox.saleschannel = this.dynamicSalesChannelList
										this.configCheckUnicommerceClientWise(clientid, this.addbox.orderid, shipmentIdForUnicommerce, userdetail.warehouseid)
										// if (this.addbox.seller === "Flipkart") {
										// 	this.addbox.saleschannel.push({
										// 		'courierid': 'E-Com',
										// 		'couriername': 'E-Com'
										// 	}, {
										// 		'courierid': 'E-Kart',
										// 		'couriername': 'E-Kart'
										// 	}, {
										// 		'courierid': 'Delhivery',
										// 		'couriername': 'Delhivery'
										// 	});
										// 	this.addbox.couriername = this.addbox.saleschannel[0].couriername;
										// } else if (this.addbox.seller === "Flipkart Lite") {
										// 	this.addbox.saleschannel.push({
										// 		'courierid': 'E-Com',
										// 		'couriername': 'E-Com'
										// 	});
										// 	this.addbox.couriername = this.addbox.saleschannel[0].couriername;
										// } else if (this.addbox.seller === "Amazon") {
										// 	this.addbox.saleschannel.push({
										// 		'courierid': 'ATS',
										// 		'couriername': 'ATS'
										// 	});
										// 	this.addbox.couriername = this.addbox.saleschannel[0].couriername;
										// } else if (this.addbox.seller === "Myntra") {
										// 	this.addbox.saleschannel.push({
										// 		'courierid': 'Myntra',
										// 		'couriername': 'Myntra'
										// 	});
										// 	this.addbox.couriername = this.addbox.saleschannel[0].couriername;
										// } else if (this.addbox.seller === "Jabong") {
										// 	this.addbox.saleschannel.push({
										// 		'courierid': 'Myntra',
										// 		'couriername': 'Myntra'
										// 	});
										// 	this.addbox.couriername = this.addbox.saleschannel[0].couriername;
										// } else if (this.addbox.seller === "Paytm") {
										// 	this.addbox.saleschannel.push({
										// 		'courierid': 'Xpressbees',
										// 		'couriername': 'Xpressbees'
										// 	}, {
										// 		'courierid': 'Bluedart',
										// 		'couriername': 'Bluedart'
										// 	}, {
										// 		'courierid': 'E-Com',
										// 		'couriername': 'E-Com'
										// 	}, {
										// 		'courierid': 'Gati',
										// 		'couriername': 'Gati'
										// 	}, {
										// 		'courierid': 'Delhivery',
										// 		'couriername': 'Delhivery'
										// 	}, {
										// 		'courierid': 'Amara',
										// 		'couriername': 'Amara'
										// 	}, {
										// 		'courierid': 'Shadowfax P2P',
										// 		'couriername': 'Shadowfax P2P'
										// 	}, {
										// 		'courierid': 'Shadofax Express',
										// 		'couriername': 'Shadofax Express'
										// 	});
										// 	this.addbox.couriername = this.addbox.saleschannel[0].couriername;
										// } else {
										// 	this.addbox.saleschannel.push({
										// 		'courierid': 'E-Kart',
										// 		'couriername': 'E-Kart'
										// 	}, {
										// 		'courierid': 'ATS',
										// 		'couriername': 'ATS'
										// 	}, {
										// 		'courierid': 'Myntra',
										// 		'couriername': 'Myntra'
										// 	}, {
										// 		'courierid': 'Xpressbees',
										// 		'couriername': 'Xpressbees'
										// 	}, {
										// 		'courierid': 'Bluedart',
										// 		'couriername': 'Bluedart'
										// 	}, {
										// 		'courierid': 'E-Com',
										// 		'couriername': 'E-Com'
										// 	}, {
										// 		'courierid': 'Gati',
										// 		'couriername': 'Gati'
										// 	}, {
										// 		'courierid': 'Delhivery',
										// 		'couriername': 'Delhivery'
										// 	}, {
										// 		'courierid': 'Amara',
										// 		'couriername': 'Amara'
										// 	}, {
										// 		'courierid': 'Shadowfax P2P',
										// 		'couriername': 'Shadowfax P2P'
										// 	}, {
										// 		'courierid': 'Shadofax Express',
										// 		'couriername': 'Shadofax Express'
										// 	}, {
										// 		'courierid': 'Others',
										// 		'couriername': 'Others'
										// 	}, );
										// }

									} else {
										this.xbIntegration = result[0].data.xbEcomFlag
										if (this.xbIntegration) {
											this.addbox.awbno = result[0].data.awbNo
											this.addbox.saleschannel.push({
												'courierid': result[0].data.courierCompany,
												'couriername': result[0].data.courierCompany
											});
											this.addbox.couriername = result[0].data.courierCompany
										} else {
											if (clientid == 1004) {
												//start of Logic for if shipping_id found
												this.isrubiconshipment = true;
												this.flag2 = true;
												this.shipmentStatus = response.data.data[0].data.shipmentData.status_name;
												let channel_name = response.data.data[0].data.shipmentData != undefined ? response.data.data[0].data.shipmentData.channel_name : ''
												let courier_name = response.data.data[0].data.shipmentData != undefined ? response.data.data[0].data.shipmentData.courier_details.courier_name : '';
												// For testing
												if (courier_name == "" || courier_name == null) {
													// courier_name = 'Gati';
												}
												// if (clientid == 1005) {
												// 	courier_name = "E-Com"
												// }

												this.addbox.seller = channel_name;
												this.addbox.saleschannel.push({
													'courierid': courier_name,
													'couriername': courier_name
												});
												this.addbox.couriername = this.addbox.saleschannel[0].couriername.trim();
												if (this.addbox.couriername == 'Amazon') {
													this.addbox.awbno = ''
												}
												this.configCheckRubiconClientWise(clientid)
												//end of Logic for if shipping_id found
											} else {
												//start of logic unicommerce if shipment id  found
												this.configCheckUnicommerceClientWise(clientid, this.addbox.orderid, shipmentIdForUnicommerce, userdetail.warehouseid)
											}
										}
									}
								} else {
									this.isLoading = false;
									//start of Logic for if shipping_id found
									this.shipmentPrintNotAvailable = false;
									this.shipmentPrintNotAvailableMSG = '';
									//end of Logic for if shipping_id found

									this.addbox.awbno = '';
									this.showboxdetails = false;
									this.$alertify.error(response.data.data[0].msg);
									this.orderDetails = {}
									if (result[0].data.length > 0) {
										for (var i = 0; i < result[0].data.length; i++) {
											this.boxStatus = result[0].data[i].boxstatus;
											this.orderStatus = result[0].data[i].status;
											if (result[0].data[i].shipment_id == null) {
												result[0].data[i].shipment_id = ""
											}

											this.orderDetails = {
												"orderid": result[0].data[i].order_id,
												"saleschannel": result[0].data[i].saleschannel,
												"shipmentid": result[0].data[i].shipment_id,
												"boxproductqty": this.totalquantity - this.cancel,
											}
											if (result[0].data.awbno && result[0].data.awbno != '') {
												this.orderDetails.awbno = result[0].data.awbno
											}
											if (result[0].data.shippingcompany && result[0].data.shippingcompany != '') {
												this.orderDetails.shippingcompany = result[0].data.shippingcompany
											}
											if (result[0].data.totalorderqty && result[0].data.totalorderqty != '') {
												if (result[0].data.totalorderqty == null) {
													this.orderDetails.Orderqty = ''
												} else {
													this.orderDetails.Orderqty = result[0].data.totalorderqty
												}
											}
										}
										if (this.orderStatus == "dispatched" || this.orderStatus == "packed" || this.orderStatus == "rto" || this.orderStatus == "cancelled") {
											this.showOrderDetails = true
										}
									}
								}
							})
							.catch((error) => {
								this.isLoading = false;
								this.errorReport(error);
							});
					}
				}).catch((error) => {
					this.isLoading = false;
					this.errorReport(error);
				});
			return false
		},

		getweight: function() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			axios({
					method: "get",
					url: apiUrl.local_printer_api_url + "getWeight",
					data: ({}),
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((weightResponse) => {
					if (weightResponse.status == 200 && weightResponse.data.weight) {
						this.addbox.boxweight = parseFloat(weightResponse.data.weight);
					} else {
						this.$alertify.error("Weighing machine is not installed properly");
						this.addbox.boxweight = 0;
					}
				})
				.catch((error) => {
					this.errorReport(error.response);
				});
		},

		scanboxid() {
			document.getElementById('submitbtn').setAttribute('disabled', true);
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.productCheckIcon = this.loadingText;
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			if (!this.warehouse && this.systemLoginCheck && !this.warehouseLoginCheck) {
				this.$alertify.error(this.$t('common.warehousePlaceholder'));
				return false;
			}
			if (this.systemLoginCheck && !this.warehouseLoginCheck) {
				userdetail.warehouseid = this.warehouse
			}
			//start
			axios({
					method: "post",
					url: apiUrl.api_url + "getboxclient",
					data: ({
						warehouseid: userdetail.warehouseid,
						boxid: this.addbox.boxid,
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((clientdata) => {
					if (clientdata.data.data[0].ErrorCode == -1) {
						document.getElementById('submitbtn').removeAttribute('disabled');
						this.productCheckIcon = '';
						this.$alertify.error(clientdata.data.data[0].msg);
					} else if (clientdata.data.data[0].ErrorCode == 0) {
						this.dynamicSalesChannelList = clientdata.data.data[0].data[0].dynamicSalesChannelList
						var clientid = clientdata.data.data[0].data[0].clientid;
						axios({
								method: "post",
								url: apiUrl.api_url + "getboxshipingstatus",
								data: ({
									clientid: clientid,
									warehouseid: userdetail.warehouseid,
									boxid: this.addbox.boxid,
								}),
								headers: {
									'Authorization': 'Bearer ' + myStr,
								}
							})
							.then((boxResponse) => {
								if (boxResponse.data.data[0].ErrorCode == -1) {
									this.productCheckIcon = '';
									this.$alertify.error(boxResponse.data.data[0].msg)
								} else if (boxResponse.data.data[0].ErrorCode == 0) {
									if (boxResponse.data.data[0].data.shipmentstatus == 'ready') {
										this.productCheckIcon = '';
										this.$alertify.error('Box is already packed and ready for shipment');
									} else if (boxResponse.data.data[0].data.shipmentstatus == 'dispached') {
										this.productCheckIcon = '';
										this.$alertify.error('Box is already dispached');
									} else if (boxResponse.data.data[0].data.shipmentstatus == 'received') {
										this.productCheckIcon = '';
										this.$alertify.error('Box is already delivered');
									} else if (boxResponse.data.data[0].data.shipmentstatus == 'rto') {
										this.productCheckIcon = '';
										this.$alertify.error('Shipment is marked as return to origin');
									} else if (boxResponse.data.data[0].data.shipmentstatus == 'packed' || boxResponse.data.data[0].data.shipmentstatus == null || boxResponse.data.data[0].data.shipmentstatus == 'failed') {
										// input details
										this.input = ({
											clientid: clientid,
											warehouseid: userdetail.warehouseid,
											boxid: this.addbox.boxid,
											useremail: userdetail.email,
											userid: userdetail.userid,
											boxweight: '' + this.addbox.boxweight,
											awbno: this.addbox.awbno.trim(),
											couriername: this.addbox.couriername.trim(),
											boxl: this.boxl,
											boxb: this.boxb,
											boxh: this.boxh,
											xbAWBCheck: this.xbIntegration
										});
										if (boxResponse.data.data[0].data.boxstatus == 'in_packing') {
											axios({
													method: "post",
													url: apiUrl.api_url + "boxpacking",
													data: this.input,
													headers: {
														'Authorization': 'Bearer ' + myStr
													}
												})
												.then((response) => {
													if (response.data.data[0].ErrorCode == -1) {
														this.productCheckIcon = '';
														this.$alertify.error(response.data.data[0].msg)
													} else if (response.data.data[0].ErrorCode == 0) {
														if (response.data.data[0].status == true) {
															this.input = ({
																clientid: clientid,
																warehouseid: userdetail.warehouseid,
																boxid: this.addbox.boxid,
																useremail: userdetail.email,
																userid: userdetail.userid,
																boxweight: '' + this.addbox.boxweight
															});

															axios({
																	method: "post",
																	url: apiUrl.api_url + "readytoship",
																	data: this.input,
																	headers: {
																		'Authorization': 'Bearer ' + myStr
																	}
																})
																.then((Shipresponse) => {
																	this.shipmentPrintNotAvailable = false;
																	this.shipmentPrintNotAvailableMSG = '';

																	if (Shipresponse.data.data[0].ErrorCode == -1) {
																		this.productCheckIcon = '';
																		this.$alertify.error(Shipresponse.data.data[0].msg)
																	} else if (Shipresponse.data.data[0].ErrorCode == 0) {
																		if (clientid == 1005) {
																			this.checkManualOrAutoPacking(this.showButtonManualPacking, this.addbox.orderid, clientid)
																		}
																		this.updateLabelInvoiceForUniCommerce(clientid, userdetail.warehouseid, this.addbox.orderid, this.addbox.couriername.trim())
																		if (clientid == 1010) {
																			this.updateLabelInvoiceForWmall(clientid, userdetail.warehouseid, this.addbox.orderid, this.addbox.couriername.trim())
																		}
																		if (clientid == 1001 && clientid == 1002 && clientid == 1003) {
																			var invoice_array = [];
																			if (Shipresponse.data.data[0].data.printData.invoiceData) {
																				invoice_array.push(Shipresponse.data.data[0].data.printData.invoiceData);
																			}
																			if (Shipresponse.data.data[0].data.printData.custinvoice) {
																				invoice_array.push(Shipresponse.data.data[0].data.printData.custinvoice);
																			}

																			this.printInvCod(Shipresponse, invoice_array);

																		} else {
																			if (Shipresponse.data.data[0].data.awbno && Shipresponse.data.data[0].data.awbno != '') {
																				this.awbnoForPrint = Shipresponse.data.data[0].data.awbno
																			}
																			this.getPrintInvoiceEnableOrDisable(clientid);
																		}
																		this.reset();
																		this.productCheckIcon = '';
																		this.$alertify.success(Shipresponse.data.data[0].msg);
																	}
																})
																.catch((error) => {
																	document.getElementById('submitbtn').removeAttribute('disabled');
																	this.errorReport(error);
																});
														}
													}
													this.addbox.isSearching = '';
													this.boxid = '';
												})
												.catch((error) => {
													document.getElementById('submitbtn').removeAttribute('disabled');
													this.errorReport(error);
												});
										} else if (boxResponse.data.data[0].data.boxstatus == 'in_shipping') // ready to ship
										{
											this.input = ({
												clientid: clientid,
												warehouseid: userdetail.warehouseid,
												boxid: this.addbox.boxid,
												useremail: userdetail.email,
												userid: userdetail.userid,
												boxweight: '' + this.addbox.boxweight
											});
											axios({
													method: "post",
													url: apiUrl.api_url + "readytoship",
													data: this.input,
													headers: {
														'Authorization': 'Bearer ' + myStr
													}
												})
												.then((Shipresponse) => {
													if (Shipresponse.data.data[0].ErrorCode == -1) {
														this.productCheckIcon = '';
														this.$alertify.error(Shipresponse.data.data[0].msg)
													} else if (Shipresponse.data.data[0].ErrorCode == 0) {
														if (clientid == 1001 && clientid == 1002 && clientid == 1003) {
															var invoice_array = [];
															if (Shipresponse.data.data[0].data.printData.invoiceData) {
																invoice_array.push(Shipresponse.data.data[0].data.printData.invoiceData);
															}
															if (Shipresponse.data.data[0].data.printData.custinvoice) {
																invoice_array.push(Shipresponse.data.data[0].data.printData.custinvoice);
															}
															this.printInvCod(Shipresponse, invoice_array);
														} else {
															if (Shipresponse.data.data[0].data.awbno && Shipresponse.data.data[0].data.awbno != '') {
																this.awbnoForPrint = Shipresponse.data.data[0].data.awbno
															}
															this.getPrintInvoiceEnableOrDisable(clientid);
														}
														this.shipmentPrintNotAvailable = false;
														this.shipmentPrintNotAvailableMSG = '';
														this.reset();
														this.productCheckIcon = '';
														this.$alertify.success(Shipresponse.data.data[0].msg);
													}
												})
												.catch((error) => {
													document.getElementById('submitbtn').removeAttribute('disabled');
													this.errorReport(error);
												});
										} else {
											this.productCheckIcon = '';
											this.$alertify.error('Box has invalid status, cannot process further');
										}
									} else {
										this.productCheckIcon = '';
										this.$alertify.error('Box has invalid status, cannot process further');
									}
								}
								document.getElementById('submitbtn').removeAttribute('disabled');
							})
							.catch((error) => {
								document.getElementById('submitbtn').removeAttribute('disabled');
								this.errorReport(error);
							});
					}
				})
				.catch((error) => {
					document.getElementById('submitbtn').removeAttribute('disabled');
					this.errorReport(error);
				});
			//end
		},
		errorReport: function(error) {
			if (error.response) {
				// The request was made and the server responded with a status code that falls out of the range of 2xx
				this.$alertify.error(error.response.data.message);
			} else if (error.request) {
				// The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of
				// http.ClientRequest in node.js
				this.$alertify.error("Request cannot be completed or timeout");
			} else {
				// Something happened in setting up the request that triggered an Error
				this.$alertify.error(error.message);
			}
		},

		printInvCod: function(Shipresponse) {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			axios({
					method: "POST",
					'url': apiUrl.local_printer_api_url + 'printer/printcod',
					data: {
						codData: Shipresponse.data.data[0].data.printData.codData,
						invoices: invoice_array,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					if (response.data.code == 200) {
						this.$alertify.success('Invoice and COD Sticker is printed successfully');
					} else {
						this.$alertify.error('Failed to print, please reset or reinstall printers correctly');
					}
				})
				.catch((error) => {
					document.getElementById('submitbtn').removeAttribute('disabled');
					this.errorReport(error);
				});
		},

		//validate all form fields on onsubmit()
		onSubmitForm: function(event) {
			this.$validator.validateAll().then(() => {}).catch(() => {
				this.errorReport(error);
			});
		},

		reset: function() {
			this.cancel = 0;
			this.canceldetails = [];
			this.cancelmodalShow = false;
			this.Confirmationcheck = false;
			this.minisocheck = false;
			this.boxl = '';
			this.boxb = '';
			this.boxh = '';
			this.showboxdetails = false;
			this.addbox.boxid = 0;
			this.addbox.boxweight = 0;
			this.addbox.orderid = '';
			this.addbox.couriername = '';
			this.addbox.seller = '';
			this.addbox.awbno = '';
			this.boxdetails = [];
			document.getElementById('boxid').value = '';
			document.getElementById('boxweight').value = 0;
			this.$validator.reset();
			this.shipmentPrintNotAvailableMSG = '';
		},
		validateSpiltBoxID() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.addspilitbox.spilitBoxID == '' || this.addspilitbox.spilitBoxID == null) {
				this.$alertify.error("Box ID required");
				return false;
			}
			this.input = ({
				"clientid": Number(this.client),
				"warehouseid": Number(window.localStorage.getItem("selectedWarehouse")),
				"orderid": this.addbox.orderid,
				"boxid": Number(this.addspilitbox.spilitBoxID),
				"userid": this.userid,
				"itemid": this.itemid,
				"shipmentid": this.shipmentid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'validateBox',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.errorCode == -1) {
						this.errorofsplitbox = false;
						this.$alertify.error('Invalid Box ID')

					}
					if (result.data.data.ErrorCode == 0 && result.data.data.data.length > 0) {
						this.errorofsplitbox = true
						this.$alertify.success(result.data.data.msg)

					}
					if (result.data.data.ErrorCode == 0 && result.data.data.data == '') {
						this.errorofsplitbox = false
						this.$alertify.error(result.data.data.msg)
					}
					if (result.data.data.ErrorCode == -1) {
						this.errorofsplitbox = false
						this.$alertify.error('Invalid Box ID')

					}
				}, error => {
					console.error(error);
				});
		},
		resetSpiltBox() {
			this.addspilitbox.spilitBoxID = '';
			this.addspilitbox.productid = '';
			this.errorofsplitbox = false;

		},
		scanProduct() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.scanproductData = []
			this.isRejectReason = false
			if (this.productid == '') {
				this.isscanproducterror = '1',
					this.scanproducterror = 'The Product ID field is required.'
				return false;
			} else {
				this.isscanproducterror = '',
					this.scanproducterror = ''
			}
			this.input = ({
				"clientid": Number(this.client),
				"warehouseid": Number(window.localStorage.getItem("selectedWarehouse")),
				"orderid": this.addbox.orderid,
				"boxid": Number(this.addbox.boxid),
				"productid": this.productid,
				"qty": 1,
				"useremail": this.useremail
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'validateProductPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.errorCode == -1) {
						this.$alertify.error(result.data.msg)
					}
					this.fullErrorMessage = '';
					if (result.data.data[0].ErrorCode == 0) {
						this.ProductID = result.data.data[0].data.productid;
						this.scanproductData = result.data.data[0].data;
						this.showproductdetails = true
						this.showproductdetailsbtn = true
						this.fullErrorMessage = ''
						if ((this.totalquantity - this.cancel) === this.qcacceptqty) {
							this.showproductdetails = false
							this.showproductdetailsbtn = false
							this.$alertify.error('Product for this BoxId already Scanned')
						}
					}
					if (result.data.data[0].ErrorCode == -1) {
						this.splitboxDone = true;
						this.scanproductData = [];
						this.fullErrorMessage = result.data.data[0].msg;
						this.showproductdetails = false;
						this.showproductdetailsbtn = false;
					}
				}, error => {
					console.error(error);
				});
		},
		RejectProductDetails() {
			this.showproductdetailsbtn = false
			this.isRejectReason = true
		},
		saveRejectReason() {
			if (this.checkedNames.length == 0) {
				this.$alertify.error('Please select reject reasons')
				return false;
			} else {
				this.ProductDetails('reject')
			}
		},
		ProductDetails(value) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.qcstatus = value
			if (this.checkedNames.indexOf('Other') > -1) {
				var index = this.checkedNames.indexOf('Other')
				if (this.otherreason == '') {
					this.isCheckboxError = '1'
					this.Checkboxerrors = 'Enter reason'
					return false;
				} else {
					this.isCheckboxError = ''
					this.Checkboxerrors = ''
					this.checkedNames.push(this.otherreason)
				}
			}
			this.rejectreasons = this.checkedNames.map(function(val) {
				if (val != 'Other' && val.trim() != '')
					return val
				else
					return null
			}).filter(function(value) {
				return value != null;
			})
			if (this.qcstatus == 'reject') {
				this.checkedNames = this.rejectreasons
			}
			this.isLoading = true
			this.input = ({
				"clientid": Number(this.client),
				"warehouseid": Number(window.localStorage.getItem("selectedWarehouse")),
				"orderid": this.addbox.orderid,
				"boxid": Number(this.addbox.boxid),
				"productid": Number(this.ProductID),
				"qcstatus": this.qcstatus,
				"rejectreasons": this.checkedNames,
				"qty": 1,
				"useremail": this.useremail
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'packingProductQC',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data[0].ErrorCode == 0) {
						// this.qcacceptqty = result.data.data[0].data.allQC.totalQCAcceptQty
						// this.qcrejectqty = result.data.data[0].data.allQC.totalQCRejectQty;
						this.isLoading = false
						this.$alertify.success(result.data.data[0].msg)
						this.getBoxDetails(0);
						this.productid = ''
						this.otherreason = ''
						this.checkedNames = []
						this.rejectreasons = []
						this.showproductdetails = false
						this.showproductdetailsbtn = false
						this.isOtherReason = false
						this.isRejectReason = false
						if ((Number(this.qcacceptqty) + Number(this.qcrejectqty) >= (Number(this.totalquantity) - Number(this.cancel))) && Number(this.qcrejectqty > 0)) {
							this.showQCSection = false
						} else {
							this.showQCSection = true
						}
						if ((this.totalquantity - this.cancel) === this.qcacceptqty) {
							this.showButton = true
							//this.getBoxDetails();
						} else {
							this.showButton = false
						}
					}
				}, error => {
					console.error(error);
				});
		},
		clearerror() {
			if (this.otherreason == '') {
				this.isCheckboxError = '1'
				this.Checkboxerrors = 'Enter reason'
			} else {
				this.isCheckboxError = ''
				this.Checkboxerrors = ''
			}
		},
		cancelReason() {
			this.showproductdetailsbtn = true
			this.isRejectReason = false
			this.isOtherReason = false
			this.otherreason = ''
			this.checkedNames = []
		},
		checkOtherReason() {
			if (this.checkedNames.indexOf('Other') > -1) {
				this.isOtherReason = true
			} else {
				this.isOtherReason = false
				this.otherreason = ''
			}
		},
		checkAwb() {
			// if (this.client == 1005) {
			// 	this.addbox.awbno = 'AWB' + this.addbox.boxid;
			// 	//soumen sir  api
			// 	this.scanboxid();
			// } else {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.awbnoForPrint = ''
			this.clientidForPrint = ''
			this.warehouseidForPrint = ''
			this.orderidForPrint = ''
			this.shippingcompanyForPrint = ''
			this.input = ({
				shippingcompany: this.addbox.couriername.trim(),
				awbno: this.addbox.awbno.trim(),
				orderid: this.addbox.orderid,
				clientid: Number(this.client)
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'checkAWBPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.flag = false;
					this.flag2 = false;
					if (result.data.data[0].ErrorCode == 0) {
						// this.getPrintInvoiceEnableOrDisable(Number(this.client));
						this.awbnoForPrint = this.addbox.awbno.trim(),
							this.clientidForPrint = Number(this.client),
							this.orderidForPrint = this.addbox.orderid,
							this.shippingcompanyForPrint = this.addbox.couriername.trim(),
							this.warehouseidForPrint = Number(window.localStorage.getItem("selectedWarehouse")),
							this.scanboxid();
					} else {
						this.$alertify.error(result.data.data[0].msg);
						return false;
					}
				}, error => {
					console.error(error)
				})
			// }

		},

		getBoxWeight() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.addbox.boxweight = 0;
			document.getElementById('boxweight').value = 0;
			this.input = ({
				boxid: this.addbox.boxid,
				clientid: Number(this.client)
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getBoxWeight',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data[0].ErrorCode == 0) {
						let weighttotal = 0
						for (var i = 0; i < result.data.data[0].data.length; i++) {
							weighttotal = weighttotal + result.data.data[0].data[i].weight
						}
						var weightround = (weighttotal / 1000).toFixed(4);
						this.addbox.boxweight = weightround;
						document.getElementById('boxweight').value = weightround;
					} else {
						this.addbox.boxweight = 0;
						document.getElementById('boxweight').value = 0;
						this.$alertify.error("Box Weight Details Not Found");
					}
				}, error => {
					console.error(error)
				})
		},

		printInvoice() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			if (!localStorage("selectedWarehouse") && this.systemLoginCheck && !this.warehouseLoginCheck) {
				this.$alertify.error(this.$t('common.warehousePlaceholder'));
				return false;
			}
			if (this.systemLoginCheck && !this.warehouseLoginCheck) {
				userdetail.warehouseid = this.warehouse
			}

			axios({
					method: "post",
					url: apiUrl.api_url + "getboxclient",
					data: ({
						warehouseid: localStorage("selectedWarehouse"),
						boxid: this.addbox.boxid,
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((clientdata) => {
					this.client = clientdata.data.data[0].data.clientid;
					if (clientdata.data.data[0].ErrorCode == -1) {
						document.getElementById('submitbtn').removeAttribute('disabled');
						this.productCheckIcon = '';
						this.$alertify.error(clientdata.data.data[0].msg);
					} else if (clientdata.data.data[0].ErrorCode == 0) {
						this.dynamicSalesChannelList = clientdata.data.data[0].data[0].dynamicSalesChannelList
						var clientid = clientdata.data.data[0].data[0].clientid;
						this.input = ({
							clientid: clientid,
							boxid: this.addbox.boxid,
						});
						axios({
								method: "post",
								url: apiUrl.api_url + "getPrintUrl",
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								},
							})
							.then((response) => {
								if (response.data.ErrorCode == 0) {
									if (response.data.data.invoice_document_external_url) {
										window.open(response.data.data.invoice_document_external_url, "_blank");
									} else {
										this.$alertify.error('Invoice URL not found');
									}
								} else {
									this.$alertify.error(result.data.msg);
								}
							})
							.catch((error) => {
								this.errorReport(error);
							});
					}
				}).catch((error) => {
					this.errorReport(error);
				});
			return false
		},
		resetInfo() {
			this.fullErrorMessage = "";
			this.addbox.awbno = "";
			this.productid = "";
			this.scanproductData = [];
			this.showproductdetails = false;
		},
		printLabel() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			if (!this.warehouse && this.systemLoginCheck && !this.warehouseLoginCheck) {
				this.$alertify.error(this.$t('common.warehousePlaceholder'));
				return false;
			}
			if (this.systemLoginCheck && !this.warehouseLoginCheck) {
				userdetail.warehouseid = this.warehouse
			}

			axios({
					method: "post",
					url: apiUrl.api_url + "getboxclient",
					data: ({
						warehouseid: userdetail.warehouseid,
						boxid: this.addbox.boxid,
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((clientdata) => {
					this.client = clientdata.data.data[0].data.clientid;
					if (clientdata.data.data[0].ErrorCode == -1) {
						document.getElementById('submitbtn').removeAttribute('disabled');
						this.productCheckIcon = '';
						this.$alertify.error(clientdata.data.data[0].msg);
					} else if (clientdata.data.data[0].ErrorCode == 0) {
						this.dynamicSalesChannelList = clientdata.data.data[0].data[0].dynamicSalesChannelList
						var clientid = clientdata.data.data[0].data[0].clientid;
						this.input = ({
							clientid: clientid,
							boxid: this.addbox.boxid,
						});
						axios({
								method: "post",
								url: apiUrl.api_url + "getPrintUrl",
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								},
							})
							.then((response) => {
								if (response.data.ErrorCode == 0) {
									if (response.data.data.shipping_label_document_external_url) {
										window.open(response.data.data.shipping_label_document_external_url, "_blank");
									} else {
										this.$alertify.error('Label URL not found');
									}
								} else {
									this.$alertify.error(result.data.msg);
								}
							})
							.catch((error) => {
								this.errorReport(error);
							});
					}
				}).catch((error) => {
					this.errorReport(error);
				});
			return false
		},
		PrintLabelAgaintsClient() {
			if (this.shipmentPrintNotAvailable) {
				this.printLabel();
			} else {
				this.printConfigLabel();
			}
		},
		PrintInvoiceAgaintsClient() {
			if (this.shipmentPrintNotAvailable) {
				this.printInvoice();
			} else {
				this.btnDisable = true
				this.printConfigprintInvoice();
				// document.getElementById("invoicebutton").disabled = true;
			}
		},
		getPrintInvoiceEnableOrDisable(clientid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input = ({
				localclientid: clientid,
				warehouseidlocal: ''
			});
			axios({
					method: "post",
					url: apiUrl.api_url + "getconfig",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((response) => {
					if (response.status == 200) {
						var result = response.data
						var isprintEnable = false;
						for (var i = 0; i < result.length; i++) {
							if (result[i].type == "print_invoice_ONOFF") {
								if (result[i].flag == "no") {
									this.printInvoiceEnable = false
								} else {
									this.printInvoiceEnable = true
								}
							}
							if (result[i].type == "print_label_ONOFF") {
								if (result[i].flag == "no") {
									this.printLabelEnable = false
								} else {
									this.printLabelEnable = true
								}
							}
						}
					} else {
						this.$alertify.error("Config Details Not Found");
					}
				}).catch((error) => {
					this.errorReport(error);
				});
		},
		printConfigprintInvoice() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var a = ''
			var input = ({
				clientid: this.clientidForPrint,
				warehouseid: this.warehouseidForPrint,
				awbno: this.awbnoForPrint,
				orderid: this.orderidForPrint,
				shippingcompany: this.shippingcompanyForPrint,
			})
			axios({
					method: "post",
					url: apiUrl.api_url + "getinvoicedata",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((response) => {
					if (response.status) {
						a = response.data.printData.invoiceData.replace("/n", "")
						var myWindow = window.open("", "MsgWindow", "_blank");
						setTimeout(function() {
							myWindow.document.write(a);
						}, 2000);
						myWindow.document.title = 'TaxInvoice';
						setTimeout(function() {
							myWindow.print()
						}, 4000);
						this.btnDisable = false
					} else {
						this.$alertify.error("Invoice URL not found");
						this.btnDisable = false;
					}
				}).catch((error) => {
					this.btnDisable = false;
					this.errorReport(error);
				});
		},
		printConfigLabel() {
			if (this.clientidForPrint == '') {
				this.$alertify.error("Invalid Client");
				return false;
			}
			if (this.warehouseidForPrint == '') {
				this.$alertify.error("Invalid Warehouse");
				return false;
			}
			if (this.awbnoForPrint.trim() == '') {
				this.$alertify.error("Invalid AWBNo");
				return false;
			}
			if (this.orderidForPrint.trim() == '') {
				this.$alertify.error("Invalid Orderid");
				return false;
			}
			if (this.shippingcompanyForPrint.trim() == '') {
				this.$alertify.error("Invalid Shipping Company");
				return false;
			}
			let routeData = ''
			routeData = this.$router.resolve({
				name: 'shippinglabel',
				params: {
					"clientid": this.clientidForPrint,
					"warehouseid": this.warehouseidForPrint,
					"awbno": this.awbnoForPrint,
					"orderid": this.orderidForPrint,
					"shippingcompany": this.shippingcompanyForPrint,
				},
				query: {
					clientid: this.clientidForPrint,
					warehouseid: this.warehouseidForPrint,
					awbno: this.awbnoForPrint,
					orderid: this.orderidForPrint,
					shippingcompany: this.shippingcompanyForPrint,
				},
			});
			window.open(routeData.href, '_blank');
		},
		//new code for unicommerce starting below
		configCheckUnicommerceClientWise(clientid, orderid, shipmentid, warehouseid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			var input = ({
				"clientid": localStorage.getItem("selectedClient"),
				"modulename": "marketplace",
				"orderid": orderid,
			})
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "configCheckUnicommerceClientWise",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((result) => {
					if (result.data.data[0].ErrorCode == 0) {
						if (result.data.data[0].data.data[0].maxval && result.data.data[0].data.data[0].maxval == 'auto' && shipmentid != null && shipmentid != '') {
							if (result.data.data[0].data.ismultiseller == false) {
								this.isUnicommerce = true
								this.getLabelInvoiceForUnicommerce(clientid, warehouseid, orderid)
								if (this.showboxdetails) {
									this.getOrderDetailsForUniCommerce(orderid, shipmentid, true, clientid, warehouseid)
								}
							} else if (shipmentid) {
								this.isMultiseller = true
								this.getFlipkartAwbdetailsAndInvoiceStatus(clientid, orderid, shipmentid, warehouseid)
							}
						} else {
							this.isUnicommerce = false
							this.isMultiseller = false
							if (clientid == 1010) {
								this.isWmall = true
								this.getLabelInvoiceForWmall(clientid, warehouseid, orderid)
								if (this.showboxdetails) {
									this.getOrderDetailsForWmall(orderid, clientid)
								}
							} else {
								this.isWmall = false
								this.addbox.saleschannel = []
								this.showLabelsButtons = false
								this.shipmentPrintNotAvailable = false
								this.isrubiconshipment = false
								this.flag2 = false
								this.isUnicommerce = false
								this.isMultiseller = false
								this.addbox.couriername = ''
								this.addbox.awbno = ''
								this.addbox.saleschannel = this.dynamicSalesChannelList
								this.$validator.reset()
							}
						}
					} else {
						this.isUnicommerce = false
						this.isMultiseller = false
						if (clientid == 1010) {
							this.isWmall = true
							this.getLabelInvoiceForWmall(clientid, warehouseid, orderid)
							if (this.showboxdetails) {
								this.getOrderDetailsForWmall(orderid, clientid)
							}
						} else {
							this.isWmall = false
							this.addbox.saleschannel = []
							//	this.showLabelsButtons = false
							this.shipmentPrintNotAvailable = false
							this.isrubiconshipment = false
							this.flag2 = false
							this.isUnicommerce = false
							this.isMultiseller = false
							this.addbox.couriername = ''
							this.addbox.awbno = ''
							this.addbox.saleschannel = this.dynamicSalesChannelList
							this.$validator.reset()
						}
					}
					this.isLoading = false
				}).catch((error) => {
					this.isLoading = false
					console.log(error, "error");
				});
		},
		updateLabelInvoiceForUniCommerce(clientid, warehouseid, orderid, shippingcompany) {
			if (this.isUnicommerce) {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				var input = ({
					"clientid": clientid,
					"warehouseid": warehouseid,
					"orderid": orderid,
					"shippingcompany": shippingcompany,
					"shippingcode": this.shippingcode,
					"shippinglabel": this.shippinglabel,
					"invoicelabel": this.invoicelabel
				})
				this.isLoading = true
				axios({
						method: "post",
						url: apiUrl.api_url + "updateLabelInvoiceForUniCommerce",
						'data': input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						},
					})
					.then((result) => {
						if (result.data.data[0].ErrorCode == 0) {
							this.getLabelInvoiceForUnicommerce(clientid, warehouseid, orderid)
							this.$alertify.success("Shipment Details Updated Successfully");
						} else {
							this.$alertify.error("Shipment Details Not Updated");
						}
						this.isLoading = false
					}).catch((error) => {
						this.isLoading = false
						console.log(error, "error");
					});
			}
		},
		getOrderDetailsForUniCommerce(orderid, shipmentid, allowManualPack, clientid, warehouseid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input
			if (shipmentid == '' || shipmentid == null || shipmentid == undefined) {
				input = ({
					"orderid": orderid,
					"clientid": clientid,
					"warehouseid": warehouseid
				})
			} else {
				input = ({
					"orderid": orderid,
					"shipmentid": shipmentid,
					"clientid": clientid,
					"warehouseid": warehouseid
				})
			}

			this.invoicelabel = ''
			this.shippinglabel = ''
			this.shippingcode = ''
			this.awbForUnicommerce = ''
			this.courierPartnerForUnicommerce = ''
			this.addbox.saleschannel = []
			this.addbox.couriername = ''
			this.addbox.awbno = ''
			this.isLoadingNew = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getOrderDetailsForUniCommerce",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((result) => {
					if (result.data.data[0].ErrorCode == 0) {
						this.invoicelabel = result.data.data[0].data.saleOrderDTO.shippingPackages[0].shippingLabelLink
						this.shippinglabel = result.data.data[0].data.saleOrderDTO.shippingPackages[0].shippingLabelLink
						this.shippingcode = result.data.data[0].data.saleOrderDTO.shippingPackages[0].code
						this.awbForUnicommerce = result.data.data[0].data.saleOrderDTO.shippingPackages[0].trackingNumber
						this.courierPartnerForUnicommerce = result.data.data[0].data.saleOrderDTO.shippingPackages[0].shippingProvider
						this.addbox.saleschannel.push({
							'courierid': this.courierPartnerForUnicommerce,
							'couriername': this.courierPartnerForUnicommerce
						})
						this.addbox.couriername = this.courierPartnerForUnicommerce
						this.addbox.awbno = this.awbForUnicommerce
						if (allowManualPack) {
							//	allow manual
							this.checkAwbCourierPartner()
						} else {
							//not allowed manual
						}
					} else {
						this.addbox.couriername = ''
						this.addbox.saleschannel = []
						this.addbox.awbno = ''
						this.invoicelabel = ''
						this.shippinglabel = ''
						this.shippingcode = ''
						this.awbForUnicommerce = ''
						this.courierPartnerForUnicommerce = ''
						if (allowManualPack) {
							//	allow manual
							this.checkAwbCourierPartner()
						} else {
							//not allowed manual
						}
						this.$alertify.error(result.data.data[0].msg)
					}
					this.isLoadingNew = false
				}).catch((error) => {
					this.isLoadingNew = false
					console.log(error, "error");
				});
		},
		getLabelInvoiceForUnicommerce(clientid, warehouseid, orderid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input = ({
				"clientid": clientid,
				"warehouseid": warehouseid,
				"orderid": orderid
			})
			this.uniCommerceLabel = ''
			this.uniCommerceShipping = ''
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getLabelInvoiceForUnicommerce",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((result) => {
					if (result.data.data[0].ErrorCode == 0) {
						this.uniCommerceLabel = result.data.data[0].data.invoicelabel
						this.uniCommerceShipping = result.data.data[0].data.shippinglabel
					} else {
						this.uniCommerceLabel = ''
						this.uniCommerceShipping = ''
					}
					this.isLoading = false
				}).catch((error) => {
					this.isLoading = false
					console.log(error, "error");
				});
		},
		printLabelUnicommerce(obj) {
			if (Number(obj) == 1) {
				if (this.showboxdetails) {
					window.open(this.invoicelabel, "_blank");
				} else {
					window.open(this.uniCommerceShipping, "_blank");
				}
			} else if (Number(obj) == 2) {
				if (this.showboxdetails) {
					window.open(this.shippinglabel, "_blank");
				} else {
					window.open(this.uniCommerceLabel, "_blank");
				}
			}
		},


		//wmall integration changes
		updateLabelInvoiceForWmall(clientid, warehouseid, orderid, shippingcompany) {
			if (this.isWmall) {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				var input = ({
					"clientid": clientid,
					"warehouseid": warehouseid,
					"orderid": orderid,
					"shippingcompany": shippingcompany,
					"shippinglabel": this.shippinglabelWmall,
					"invoicelabel": this.invoicelabelWmall
				})
				this.isLoading = true
				axios({
						method: "post",
						url: apiUrl.api_url + "updateLabelInvoiceForWmall",
						'data': input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						},
					})
					.then((result) => {
						if (result.data.data[0].ErrorCode == 0) {
							this.getLabelInvoiceForWmall(clientid, warehouseid, orderid)
							this.$alertify.success("Shipment Details Updated Successfully");
						} else {
							this.$alertify.error("Shipment Details Not Updated");
						}
						this.isLoading = false
					}).catch((error) => {
						this.isLoading = false
						console.log(error, "error");
					});
			}
		},
		getOrderDetailsForWmall(orderid, clientid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input = ({
				"orderid": orderid,
				"clientid": clientid
			})
			this.invoicelabelWmall = ''
			this.shippinglabelWmall = ''
			this.isLoadingNew = true
			this.addbox.saleschannel = []
			this.addbox.couriername = ''
			this.addbox.awbno = ''
			axios({
					method: "post",
					url: apiUrl.api_url + "getOrderDetailsForWmall",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((result) => {
					if (result.data.data[0].ErrorCode == 0) {
						if (result.data.data[0].data.orders[0].orderItems[0].status && result.data.data[0].data.orders[0].orderItems[0].status == 'CANCELLED') {
							this.addbox.couriername = ''
							this.addbox.saleschannel = []
							this.addbox.awbno = ''
							this.invoicelabelWmall = ''
							this.shippinglabelWmall = ''
							this.$alertify.error("This Order has CANCELLED Status");
						} else {
							this.invoicelabelWmall = result.data.data[0].data.orders[0].orderItems[0].shippinglabel
							this.shippinglabelWmall = result.data.data[0].data.orders[0].orderItems[0].shippinglabel
							this.addbox.saleschannel.push({
								'courierid': result.data.data[0].data.orders[0].orderItems[0].logisticInfo.courierName,
								'couriername': result.data.data[0].data.orders[0].orderItems[0].logisticInfo.courierName
							})
							this.addbox.couriername = result.data.data[0].data.orders[0].orderItems[0].logisticInfo.courierName
							this.addbox.awbno = result.data.data[0].data.orders[0].orderItems[0].logisticInfo.awbNo
						}
					} else {
						this.addbox.couriername = ''
						//this.addbox.saleschannel = []
						this.addbox.saleschannel.push({
							'courierid': 'Others',
							'couriername': 'Others'
						});
						this.isWmall = false;
						this.addbox.awbno = ''
						this.invoicelabelWmall = ''
						this.shippinglabelWmall = ''
					}
					this.isLoadingNew = false
				}).catch((error) => {
					this.isLoadingNew = false
					console.log(error, "error");
				});
		},
		getLabelInvoiceForWmall(clientid, warehouseid, orderid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input = ({
				"clientid": clientid,
				"warehouseid": warehouseid,
				"orderid": orderid
			})
			this.wmallLabel = ''
			this.wmallShipping = ''
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getLabelInvoiceForWmall",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((result) => {
					if (result.data.data[0].ErrorCode == 0) {
						this.wmallLabel = result.data.data[0].data.invoicelabel
						this.wmallShipping = result.data.data[0].data.shippinglabel
					} else {
						this.wmallLabel = ''
						this.wmallShipping = ''
					}
					this.isLoading = false
				}).catch((error) => {
					this.isLoading = false
					console.log(error, "error");
				});
		},
		printLabelWmall(obj) {
			if (Number(obj) == 1) {
				if (this.showboxdetails) {
					window.open(this.invoicelabelWmall, "_blank");
				} else {
					window.open(this.wmallShipping, "_blank");
				}
			} else if (Number(obj) == 2) {
				if (this.showboxdetails) {
					window.open(this.shippinglabelWmall, "_blank");
				} else {
					window.open(this.wmallLabel, "_blank");
				}
			}
		},
		//Manual packing function from below
		manualPackingEnable() {
			var checkbox1 = document.getElementById("manualPackingEnable").checked;
			if (checkbox1) {
				this.xbIntegration = false
				this.addbox.saleschannel = []
				this.showLabelsButtons = false
				this.shipmentPrintNotAvailable = false
				this.isrubiconshipment = false
				this.flag2 = false
				this.isUnicommerce = false
				this.isMultiseller = false
				this.addbox.couriername = ''
				this.addbox.awbno = ''
				this.addbox.saleschannel = this.dynamicSalesChannelList
				document.getElementById("manualPackingEnable").disabled = true
				this.$validator.reset();
			}
		},
		checkAwbCourierPartner() {
			if (this.addbox.couriername == '' || this.addbox.awbno == '' || this.addbox.couriername == null || this.addbox.awbno == null || !this.addbox.couriername || !this.addbox.awbno) {
				this.showButtonManualPacking = true
			}
		},
		configCheckRubiconClientWise(clientid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			var input = ({
				"clientid": clientid,
				"modulename": "marketplace",
			})
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "configCheckRubiconClientWise",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((result) => {
					if (result.data.data[0].ErrorCode == 0) {
						if (result.data.data[0].data.data[0].maxval && result.data.data[0].data.data[0].maxval == 'auto') {
							this.checkAwbCourierPartner()
						} else {
							this.addbox.saleschannel = []
							this.showLabelsButtons = false
							this.shipmentPrintNotAvailable = false
							this.isrubiconshipment = false
							this.flag2 = false
							this.isUnicommerce = false
							this.isMultiseller = false
							this.addbox.couriername = ''
							this.addbox.awbno = ''
							this.addbox.saleschannel = this.dynamicSalesChannelList
							this.$validator.reset()
						}
					} else {
						this.addbox.saleschannel = []
						//this.showLabelsButtons = false
						this.shipmentPrintNotAvailable = false
						this.isrubiconshipment = false
						this.flag2 = false
						this.isUnicommerce = false
						this.isMultiseller = false
						this.addbox.couriername = ''
						this.addbox.awbno = ''
						this.addbox.saleschannel = this.dynamicSalesChannelList
						this.$validator.reset()
					}
					this.isLoading = false
				}).catch((error) => {
					this.isLoading = false
					console.log(error, "error");
				});
		},
		//changes for new coureir partner while packing
		CourierSelected() {
			if (this.addbox.couriername && this.addbox.couriername == 'Others') {
				this.$prompt("Enter Courier Company").then(text => {
					if (text && text != '' && text != null) {
						this.addbox.saleschannel.push({
							'courierid': text.trim(),
							'couriername': text.trim()
						}, )
						this.addbox.couriername = text.trim()
						this.$alert('Courier Company Added', text, "success");
					} else {
						this.$alert('Courier Company Not Added', text, "error");
					}
				});
			}
		},
		//update order to manual if order is packed using manual(unicommerce and rubicon)
		checkManualOrAutoPacking(isManual, orderid, clientid) {
			if (isManual) {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				var userdetailEncrypt = window.localStorage.getItem('userdetail')
				var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
				var plaintext = bytes.toString(CryptoJS.enc.Utf8);
				var userdetail = JSON.parse(plaintext);
				var input = ({
					"clientid": clientid,
					"orderid": orderid,
				})
				axios({
						method: "post",
						url: apiUrl.api_url + "updateOrderManual",
						'data': input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						},
					})
					.then((result) => {
						if (result.data.data[0].ErrorCode == 0) {
							this.$alertify.success(result.data.data[0].msg)
						} else {
							this.$alertify.error(result.data.data[0].msg)
						}
						this.isLoading = false
					}).catch((error) => {
						this.isLoading = false
						console.log(error, "error");
					});
			}
		},
		//flipkart code starting below
		getFlipkartAwbdetailsAndInvoiceStatus(clientid, orderid, shipmentid, warehouseid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			this.isLoading = true
			var input = ({
				"clientid": clientid,
				"orderid": orderid,
				"shipmentid": shipmentid,
				"warehouseid": warehouseid
			})
			axios({
					method: "post",
					url: apiUrl.api_url + "getLabelAndRTDStatusFlipkart",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((result) => {
					if (result.data.data[0].ErrorCode == 0) {
						if (result.data.data[0].data.status) {
							this.getFlipkartAwbAndInvoice(clientid, orderid, shipmentid, warehouseid, true)
						} else {
							this.showLabelsButtons = false
							this.$alertify.error(result.data.data[0].msg)
							this.reset()
						}
					} else {
						this.$alertify.error(result.data.data[0].msg)
					}
					this.isLoading = false
				}).catch((error) => {
					this.isLoading = false
					console.log(error, "error");
				});
		},
		getFlipkartAwbAndInvoice(clientid, orderid, shipmentid, warehouseid, allowManualPack) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			this.invoicelabel = ''
			this.shippinglabel = ''
			this.shippingcode = ''
			this.awbForUnicommerce = ''
			this.courierPartnerForUnicommerce = ''
			this.addbox.saleschannel = []
			this.addbox.couriername = ''
			this.addbox.awbno = ''
			this.flipkartLabelInvoiceStream = []
			this.isLoadingNew = true
			var input = ({
				"clientid": clientid,
				"orderid": orderid,
				"shipmentid": shipmentid,
				"warehouseid": warehouseid
			})
			axios({
					method: "post",
					url: apiUrl.api_url + "getAwbAndInvoiceDetailsFlipkart",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((result) => {
					if (result.data.data[0].ErrorCode == 0) {
						this.flipkartLabelInvoiceStream = result.data.data[0].data.data
						this.addbox.saleschannel.push({
							'courierid': result.data.data[0].data.awbdetails.shippername,
							'couriername': result.data.data[0].data.awbdetails.shippername
						})
						this.addbox.couriername = result.data.data[0].data.awbdetails.shippername
						this.addbox.awbno = result.data.data[0].data.awbdetails.awbno
						if (allowManualPack) {
							//	allow manual
							this.checkAwbCourierPartner()
						} else {
							//not allowed manual
						}
					} else {
						this.flipkartLabelInvoiceStream = []
						this.showLabelsButtons = false
						this.addbox.couriername = ''
						this.addbox.saleschannel = []
						this.addbox.awbno = ''
						if (allowManualPack) {
							//	allow manual
							this.checkAwbCourierPartner()
						} else {
							//not allowed manual
						}
						this.$alertify.error(result.data.data[0].msg)
						//this.reset()
					}
					this.isLoadingNew = false
				}).catch((error) => {
					this.isLoadingNew = false
					console.log(error, "error");
				});
		},
		getInvoiceAndLabelFlipkart(obj) {
			let filename = this.addbox.orderid + ".pdf"
			if (obj == 1) {
				filename = "Invoice" + this.addbox.orderid + ".pdf"
			} else {
				filename = "Label" + this.addbox.orderid + ".pdf"
			}
			let data = this.flipkartLabelInvoiceStream;
			let a = document.createElement("a");
			a.href = "data:application/octet-stream;base64," + data;
			a.download = filename
			a.click();
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/packing/packing.component.js